export default "__VITE_ASSET__DCFA0bxU__"